import {
  Box,
  CircularProgress,
  Container,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material'
import { useQuery } from 'react-query'
import { adminService } from 'shared/api'
import EditIcon from '@mui/icons-material/Edit'
import CreateIcon from '@mui/icons-material/Add'
import { Link, useSearchParams } from 'react-router-dom'
import { userCreate, userEdit } from 'pages/nav'
import { useEffect, useState } from 'react'
import { SearchInput } from 'features/search-input'

function UserList() {
  const { data, isFetching } = useQuery(['users'], ({ signal }) => adminService.user.getUserList({ signal }))

  const [searchParams, setSearchParams] = useSearchParams()

  const [term, setTerm] = useState(searchParams.get('term') || '')

  useEffect(() => {
    const search = new URLSearchParams(searchParams)
    if (term) {
      search.set('term', term)
    } else {
      search.delete('term')
    }
    setSearchParams(search)
  }, [term])

  function handleTermChange(e: React.ChangeEvent<HTMLInputElement>) {
    setTerm(e.target.value)
  }

  const filteredData = data?.data?.filter?.((user) =>
    [user.email, user.firstName, user.lastName, user.firstName].join(' ').toLowerCase().includes(term.toLowerCase())
  )

  return (
    <Container maxWidth="lg">
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h6">Список сотрудников</Typography>
        <Tooltip title="Добавить сотрудника">
          <Link to={userCreate()}>
            <IconButton>
              <CreateIcon />
            </IconButton>
          </Link>
        </Tooltip>
      </Box>
      <Box sx={{ margin: '0 0.5rem 1rem' }}>
        <SearchInput value={term} onChange={handleTermChange} onClear={() => setTerm('')} />
      </Box>
      <List>
        {!!isFetching && (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        )}
        {!isFetching &&
          filteredData?.map?.((user) => (
            <ListItem key={user.id}>
              <ListItemText primary={`${user.lastName} ${user.firstName}`} secondary={user.email} />
              <ListItemSecondaryAction>
                <Tooltip title="Редактировать сотрудника">
                  <Link to={userEdit(String(user.id))}>
                    <IconButton>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Link>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
      </List>
    </Container>
  )
}

export { UserList }
